import React, {Fragment} from "react";

export default function CustomToolbarBefore() {
    return <Fragment/>
}